import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const mm = gsap.matchMedia();
      mm.add( '(min-width: 1024px)', () => {
        if ( window.hasMotion ) {
          $( '.four-column-scrolling-cards' ).each( function( key, val ) {
            const height = $( this ).outerHeight();
            const fake = $( val ).find( '.fake' )[0];
            let topOffset = $( '.navbar' ).outerHeight();

            if ( $( '#wpadminbar' ).length ) {
              topOffset += $( '#wpadminbar' ).outerHeight();
            }

            const tl = gsap.timeline( {
              scrollTrigger: {
                trigger: this,
                pin: $( val ).find( '.four-column-scrolling-cards__inner' )[0],
                start: 'top ' + topOffset,
                end: '+=3500',
                scrub: 1,
                // markers: true,
              },
            } );

            let offset = 0;
            $( val ).find( '.four-column-scrolling-cards__card' ).each( function( imageKey, image ) {
              offset = imageKey * 0.5;
              tl.fromTo( image, {y: '90vh'}, {y: '0vh', ease: 'linear', duration: 0.5, delay: offset}, 0 );
            } );

            tl.fromTo( fake, {opacity: '0'}, {opacity: '1', ease: 'linear', duration: 0.5, delay: ( offset + 0.5 )}, 0 );
          } );
        }
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'four-column-scrolling-cards', COMPONENT );
} )( app );
